let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];

class ByLastItemsService {
  constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
  }

  getLastItemsBought(userId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.fastSearchLastItemsBought}?userId=${userId}`,
        cache: false,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    })
  }

  getProducts(text, userId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.searchProduct}${text}&userId=${userId}`,
        cache: false,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }

  updateFavoriteProducts(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.setFavoriteProduct,
        cache: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: this.$httpParamSerializerJQLike(data)
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }

  getResumeProductsFavorites(userId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.fastSearchResumeFavoriteItems}?userId=${userId}&origen=B2B`,
        cache: false,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    })
  }
}

ByLastItemsService.$inject = inject;

export default ByLastItemsService



/** WEBPACK FOOTER **
 ** ./www/components/fast-purchase/by-last-items/by-last-items.service.js
 **/